import { ethers } from 'ethers';
import { LOGS_RPC, LOGS_CHUNK } from '../config/networks';
import { CONTRACTS, EVITTA_ABI } from '../config/contracts';

// Dedicated read-only contract on a logs-capable RPC (dataseed nodes reject
// eth_getLogs, so event history must go through publicnode / similar).
let _contract = null;
function getLogsContract() {
  if (_contract) return _contract;
  if (!LOGS_RPC || !CONTRACTS.evitta) return null;
  const provider = new ethers.providers.JsonRpcProvider(LOGS_RPC);
  _contract = new ethers.Contract(CONTRACTS.evitta, EVITTA_ABI, provider);
  return _contract;
}

// Most-recent PoolIncomeRoundCreated timestamp (unix seconds) for a pool type.
// Scans backward from the latest block in <=LOGS_CHUNK windows. Returns 0 if
// none found or the RPC is unavailable.
export async function getLastRoundTime(poolType, maxWindows = 30) {
  const c = getLogsContract();
  if (!c) return 0;
  try {
    const latest = await c.provider.getBlockNumber();
    const filter = c.filters.PoolIncomeRoundCreated(poolType);
    let to = latest;
    for (let i = 0; i < maxWindows && to > 0; i++) {
      const from = Math.max(0, to - LOGS_CHUNK);
      try {
        const logs = await c.queryFilter(filter, from, to);
        if (logs && logs.length) {
          const blk = await logs[logs.length - 1].getBlock();
          return blk ? Number(blk.timestamp) : 0;
        }
      } catch {
        /* this window failed — try the older one */
      }
      to = from - 1;
    }
  } catch {
    /* ignore */
  }
  return 0;
}
